import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ListPageTopBar } from "@/components/layout/dashboard-layout";
import { ListFooter } from "@/components/shared/list-footer";

import { ErrorBoundary } from "react-error-boundary";
import { RecordNotFound } from "@/components/shared/record-not-found";
import { ArrowLeftIcon, MergeIcon } from "lucide-react";
import { useMutations } from "./utils/react-hook/use-mutations";
import { ReactTable, ReactTableSkelton } from "./utils";
import { Fragment } from "react/jsx-runtime";
import ErrorFallback from "@/components/shared/error-fallback";
import { ReactEditTable } from "./utils/react-edit-table";
import { useUserInfo } from "@/global-data/use-user-info";

export const RetailerGrouping = () => {
  const {
    listData,
    onPageChange,
    onPerPageChange,
    paginationData,
    onAction,
    activeRecordData,
    onFormSubmit,
    onFormOpenChange,
    formPopupOpen,
    skeltonLoading,
    retailerList,
    sortingHandler,
    sortBy,
    orderBy,
  } = useMutations();
  const { activePermission } = useUserInfo();

  return (
    <Fragment>
      {formPopupOpen ? (
        <div className="flex flex-col gap-5">
          <ListPageTopBar
            title={
              activeRecordData
                ? "Update Retailer Grouping"
                : "Create Retailer Grouping"
            }
          >
            <Button variant={"action"} onClick={() => onFormOpenChange(false)}>
              <ArrowLeftIcon /> Back
            </Button>
          </ListPageTopBar>
          <Card className="rounded-[15px] overflow-hidden">
            <ReactEditTable
              data={activeRecordData}
              onFormSubmit={onFormSubmit}
              onOpenChange={onFormOpenChange}
              open={formPopupOpen}
              retailerList={retailerList}
            />
          </Card>
        </div>
      ) : (
        <div className="flex flex-col gap-5">
          <ListPageTopBar title="Retailer Grouping">
            {activePermission?.create ? (
              <Button variant={"action"} onClick={() => onFormOpenChange(true)}>
                <MergeIcon /> Retailer Merge
              </Button>
            ) : null}
          </ListPageTopBar>

          {skeltonLoading ? (
            <ReactTableSkelton />
          ) : (
            <Card className="overflow-hidden">
              <CardContent className="max-w-[100%] p-0 overflow-auto scrollbar h-auto min-h-[350px] md:h-[calc(100dvh-340px)]">
                <ErrorBoundary
                  fallbackRender={({ error, resetErrorBoundary }) => (
                    <ErrorFallback
                      error={error}
                      errorInfo={error.stack || ""}
                      resetErrorBoundary={resetErrorBoundary}
                    />
                  )}
                >
                  <ReactTable
                    data={listData}
                    onAction={onAction}
                    activePermission={activePermission}
                    sortingHandler={sortingHandler}
                    sortBy={sortBy}
                    orderBy={orderBy}
                  />
                  {listData.length === 0 ? <RecordNotFound /> : null}
                </ErrorBoundary>
              </CardContent>
              <ErrorBoundary
                fallbackRender={({ error, resetErrorBoundary }) => (
                  <ErrorFallback
                    error={error}
                    errorInfo={error.stack || ""}
                    resetErrorBoundary={resetErrorBoundary}
                  />
                )}
              >
                <hr />
                <ListFooter
                  onPageChange={onPageChange}
                  onPerPageChange={onPerPageChange}
                  page={paginationData.page}
                  perPage={paginationData.perPage}
                  totalItem={paginationData.totalItem}
                  className="px-5 py-5"
                  isEmpty={listData.length === 0}
                />
              </ErrorBoundary>
            </Card>
          )}
        </div>
      )}
    </Fragment>
  );
};
